import { render, staticRenderFns } from "./certificateType.vue?vue&type=template&id=79adf5ee&scoped=true"
import script from "./certificateType.vue?vue&type=script&lang=js"
export * from "./certificateType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79adf5ee",
  null
  
)

export default component.exports